import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';

@Injectable({
  providedIn: 'root',
})
export class ListingService {
  constructor(private http: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'access-token': environment.prospektr_sell_backend_access_token
    }),
  };

  GetListingPackages(company: any, state, county): Promise<any> {
    return new Promise((resolve, reject) => {
      let input = {
        companyId: company.id,
        state: state,
        county: county,
      };
      let url =
        environment.prospektr_sell_backend_base_url +
        constants.prospector_listing_get_packages;
      this.http
        .post<any>(url, input, this.httpOptions)
        .pipe(
          catchError((error) => {
            console.error('HTTP Request Error:', error);
            return throwError('Error fetching data from the server');
          })
        )
        .subscribe({
          next: (res) => {
            if (res && res.length > 0) {
              let packages = res;
              let plans = packages.plans;
              let uiReadyPackages = this.buildListingPackagesForUI(packages);
              resolve(uiReadyPackages);
            } else {
              console.error('Get ListingPackages Failed!!!!');
              reject('Empty response or invalid data structure');
            }
          },
          error: (err) => {
            // console.error('Get ListingPackages err : ', err);
            reject('Error processing data from the server');
          },
        });
    });
  }

  // call backend to get the listing packages
  async retrieveListingPackages(company: any): Promise<any> {
    let input = {
      where: {
        companyId: company.id,
      },
    };
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_listing_get_packages +
      '?filter=' +
      JSON.stringify(input);
    return this.http
      .get<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.handleErrors));
  }

  // build the UI objects for packages
  buildListingPackagesForUI(plans: any[]) {
    let packages = {
      plans: [],
      features: [],
      mobFeatures: [],
      brokerageValues: {},
      stateName: '',
    };
    let allFeatures = [];
    plans.forEach((plan: any) => {
      let packagePlan = {
        name: plan.name,
        price: plan.initialFee,
        isSelected: false,
        packageid: plan.planId,
        feeAtClosingPercentage: plan.feeAtClosingPercentage,
        feeAtClosingAmount: plan.feeAtClosingAmount,
        settlement: '',
      };
      packages.plans.push(packagePlan);

      let settlement = '';

      // if (plan.settlement && plan.settlement.value) {
      //   if (plan.settlement.dollar) {
      //     settlement = '$' + plan.settlement.value;
      //   } else if (plan.settlement.percentage) {
      //     settlement = plan.settlement.value + '%';
      //   }
      // }

      if (plan.settlement && plan.settlement.description) {
        settlement = plan.settlement.description;
      }
      packagePlan.settlement = settlement;

      let mobileFeatures = [];
      plan.features.forEach((feature: any) => {
        let packageFeature = {
          featureId: feature.featureId,
          name: feature.description,
        };
        if (!allFeatures.some((e) => e.featureId === feature.featureId)) {
          allFeatures.push(packageFeature);
        }
        mobileFeatures.push(feature.description);
      });
      packages.mobFeatures.push(mobileFeatures);
    });
    allFeatures.forEach((packageFeature: any) => {
      let filledPackageFeature = {
        text: packageFeature.name,
      };
      let i = 1;

      plans.forEach((plan: any) => {
        if (
          plan.features.some((e) => e.featureId === packageFeature.featureId)
        ) {
          let content = 'Y';
          plan.features.forEach((element) => {
            if (
              element.featureId === packageFeature.featureId &&
              element.content
            ) {
              content = element.content;
            }
          });
          filledPackageFeature['' + i] = {
            content: content,
          };
        } else {
          filledPackageFeature['' + i] = {
            content: '',
          };
        }
        i++;
      });
      packages.features.push(filledPackageFeature);
    });

    return packages;
  }

  // Error handling
  handleErrors(error: {
    error: { message: string };
    status: any;
    message: any;
  }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
